export default {
  namespaced: true,
  state: {
    //捕捉点设置
    midSnapPoint: true, //中点
    endSnapPoint: true, //端点
    intSnapPoint: false, //交点
    perSnapPoint: true, //垂足
    // minSnapPoint: false, //最近点
    tanSnapPoint: false, //切点
    cenSnapPoint: false, //圆心

    rlSnapDisplay: [1, 2, 3, 4], //捕捉点

    //图层显隐设置
    axisDisplay: false, //轴线命名
    gridDisplay: true, //网格
    cloumnDisplay: true, //柱
    beamDisplay: true, //梁
    wallDisplay: true, //墙
    slabDisplay: true, //板
    cantiSlabDisplay: true, //悬挑板
    ringDisplay: true, //圈梁
    subBeamDisplay: true, //次梁
    constructionColDisplay: true, //构造柱
    wallHoleDisplay: true, //墙洞
    modelNoDisplay: false, //构件号
    sectSizeDisplay: false, //截面尺寸
    doorsDisplay: true, //门
    windowsDisplay: true, //窗
    useDisplay: true, //用途
    partitionWallDisplay: true, //隔墙
    rlLayerDisplay: [3, 4, 5, 6, 7, 8, 9, 12, 10, 21, 22, 23, 24, 26], //图层显示控制

    lockList: [], // 构件/非结构构件 锁定列表
  },
  mutations: {
    setRLSnapDisplay(state, array) {
      state.rlSnapDisplay = array;
      state.midSnapPoint = array.includes(1);
      state.perSnapPoint = array.includes(2);
      state.endSnapPoint = array.includes(3);
      state.intSnapPoint = array.includes(4);
      state.cenSnapPoint = array.includes(5);
      state.tanSnapPoint = array.includes(6);
    },

    setRLLayerDisplay(state, array) {
      state.rlLayerDisplay = array;
      state.axisDisplay = array.includes(2);
      state.gridDisplay = array.includes(3);
      state.cloumnDisplay = array.includes(4);
      state.beamDisplay = array.includes(5);
      state.wallDisplay = array.includes(6);
      state.slabDisplay = array.includes(7);
      state.ringDisplay = array.includes(8);
      state.subBeamDisplay = array.includes(9);
      state.wallHoleDisplay = array.includes(10);
      state.modelNoDisplay = array.includes(11);
      state.cantiSlabDisplay = array.includes(12);
      state.constructionColDisplay = array.includes(26);
      state.partitionWallDisplay = array.includes(21);
      state.doorsDisplay = array.includes(22);
      state.windowsDisplay = array.includes(23);
      state.useDisplay = array.includes(24);
      state.sectSizeDisplay = array.includes(18);
    },

    setMidSnapPoint(state, value) {
      state.midSnapPoint = value;
    },
    setEndSnapPoint(state, value) {
      state.endSnapPoint = value;
    },
    setIntSnapPoint(state, value) {
      state.intSnapPoint = value;
    },
    setPerSnapPoint(state, value) {
      state.perSnapPoint = value;
    },
    setTanSnapPoint(state, value) {
      state.tanSnapPoint = value;
    },
    setCenSnapPoint(state, value) {
      state.cenSnapPoint = value;
    },
    setAxisDisplay(state, value) {
      state.axisDisplay = value;
    },
    setGridDisplay(state, value) {
      state.gridDisplay = value;
    },
    setCloumnDisplay(state, value) {
      state.cloumnDisplay = value;
    },
    setBeamDisplay(state, value) {
      state.beamDisplay = value;
    },
    setWallDisplay(state, value) {
      state.wallDisplay = value;
    },
    setSlabDisplay(state, value) {
      state.slabDisplay = value;
    },
    setCantiSlabDisplay(state, value) {
      state.cantiSlabDisplay = value;
    },
    setRingDisplay(state, value) {
      state.ringDisplay = value;
    },
    setSubBeamDisplay(state, value) {
      state.subBeamDisplay = value;
    },
    setWallHoleDisplay(state, value) {
      state.wallHoleDisplay = value;
    },
    setConstructionColDisplay(state, value) {
      state.constructionColDisplay = value;
    },
    setModelNoDisplay(state, value) {
      state.modelNoDisplay = value;
    },
    setDoorsDisplay(state, value) {
      state.doorsDisplay = value;
    },
    setWindowsDisplay(state, value) {
      state.windowsDisplay = value;
    },
    setUseDisplay(state, value) {
      state.useDisplay = value;
    },
    setPartitionWallDisplay(state, value) {
      state.partitionWallDisplay = value;
    },
    setSectSizeDisplay(state, value) {
      state.sectSizeDisplay = value;
    },
    setLockList(state, value) {
      // 如果value存在lockList中，则添加到lockList中，否则从lockList中移除
      if (state.lockList.includes(value)) {
        state.lockList = state.lockList.filter((item) => item !== value);
      } else {
        state.lockList.push(value);
      }
    },
  },
  actions: {},
  getters: {},
};
